const runtimeConfig = {
    GATSBY_ACTIVE_ENV: process.env.GATSBY_ACTIVE_ENV,
    GATSBY_URL: process.env.GATSBY_URL,
    GATSBY_CAMPAIGN_API: process.env.GATSBY_CAMPAIGN_API,
    GATSBY_CDIL_CAPTCHA: process.env.GATSBY_CDIL_CAPTCHA,
    GATSBY_CAMPAIGN_API_GLOBAL: process.env.GATSBY_CAMPAIGN_API_GLOBAL,
}

module.exports = { runtimeConfig }
